<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Segmentos
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'condition_new'})"
            >
              Crear nuevo segmento
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="getConditions()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <div class="offer_elements__category--row_container">
        <template v-for="condition in conditions">
          <v-hover>
          <div slot-scope="{ hover }" :key="condition.id" @click="$router.push({name: 'condition_edit', params: {id: condition.id}})"
          :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__category--row" >
            <p class="offer_elements__category--row_title">{{ condition.attributes.description }}</p>
            <v-icon @click.stop="deleteCondition(condition.id); getConditions()" >delete</v-icon>
          </div>
          </v-hover>
        </template >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      conditions:[]
    }
  },
  methods:{
    getConditions(){
      try {
      const data = {company: {id: this.getCompany().id}}
      this.$http.post('conditions/company',{data:this.encrypt(data).toString()},{headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.conditions = response.body.data
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    deleteCondition(id, type){
      // cl conditions
      try {
        this.$http.delete('conditions/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if (response.ok){
            for (var i = 0; i < this.conditions.length; i++) {
              if(this.conditions[i].id == id){
                // alert("El segmento "+this.conditions[i].attributes.description+" se ha eliminado correctamente")
                this.updateAlertMessage("El segmento "+this.conditions[i].attributes.description+" se ha eliminado correctamente");
                this.updateIsInAlert(true);
                this.conditions.splice(i, 1)
              }
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          // alert("Hay rewards utilizando este segmento, no se puede eliminar");
          this.updateAlertMessage("Hay rewards utilizando este segmento, no se puede eliminar");
          this.updateIsInAlert(true);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }


        })
      } catch (e) {
        // alert(e.message)
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }
    }
  },
  mounted(){
    this.getConditions();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/conditions/Index.vue